__turbopack_context__.v({
  "backdrop": "global-error-module__SDPcOG__backdrop",
  "button": "global-error-module__SDPcOG__button",
  "container": "global-error-module__SDPcOG__container",
  "content": "global-error-module__SDPcOG__content",
  "description": "global-error-module__SDPcOG__description",
  "iconWrap": "global-error-module__SDPcOG__iconWrap",
  "oops": "global-error-module__SDPcOG__oops",
  "title": "global-error-module__SDPcOG__title",
});
